export default __webpack_public_path__ + "static/media/minus.04fec70d.svg";